<div class="agpr-systemNotificationsCard agpr-contextMenu-parent">
    <div
        [id]="id + '_notification'"
        class="agpr-systemNotificationsCard-wrapper"
        [ngClass]="{
            'agpr-systemNotificationsCard--focused': focused,
            'agpr-systemNotificationsCard--selected': selected
        }"
        (agprClickUnless)="cardFocused()"
        [agprClickUnlessSelectors]="['a', 'agpr-checkbox']"
    >
        <div class="agpr-systemNotificationsCard-checkbox">
            <agpr-checkbox
                [id]="id + '_checkbox'"
                [value]="notification"
                [hiddenLabel]="notification.title"
                [(ngModel)]="selectedNotifications"
                (onChange)="cardSelected()"
                (click)="$event.stopPropagation()"
            ></agpr-checkbox>
        </div>
        <div class="agpr-systemNotificationsCard-cardInfo">
            <div class="agpr-systemNotificationsCard-titleContainer">
                <div class="agpr-systemNotificationsCard-titleContainer-type">
                    <agpr-message
                        [severity]="notification.type"
                        [iconStyle]="iconTypes.normal"
                    >
                        {{ notification.type | titlecase }}
                    </agpr-message>
                </div>
                <span class="agpr-systemNotificationsCard-titleContainer-title agpr-systemNotificationsCard-titleContainer-title--black">
                    {{ notification.title }}
                </span>
                <span
                    role="img"
                    class="agpr-systemNotificationsCard-titleContainer-statusBadge {{notification.statusBadge?.iconClass}}"
                    [agprTooltip]="notification.statusBadge?.tooltip"
                ></span>
            </div>
            <p class="agpr-systemNotificationsCard-messageContainer"> {{ notification.message }} </p>
            <div class="agpr-systemNotificationsCard-timeRange">
                <div
                    *ngIf="notification.maintenanceTimeRange"
                    class="agpr-systemNotificationsCard-timeRangeItem"
                >
                    <span class="agpr-systemNotificationsCard-timeRangeItem-label">
                        {{ 'SystemNotification.card.maintenance.start' | localize }}
                    </span>
                    <span class="agpr-systemNotificationsCard-timeRangeItem-value">
                        {{ notification.maintenanceTimeRange.startConvertedwithTz| changeTimeZone: preferences?.timeZone : defaultTimeFormat }}
                    </span>
                </div>
                <div class="agpr-systemNotificationsCard-timeRangeItem">
                    <span class="agpr-systemNotificationsCard-timeRangeItem-label">
                        {{ 'SystemNotification.card.notification.start' | localize }}
                    </span>
                    <span class="agpr-systemNotificationsCard-timeRangeItem-value">
                        {{ notification.notificationTimeRange.startConvertedwithTz | changeTimeZone: preferences?.timeZone : defaultTimeFormat }}
                    </span>
                </div>
                <div
                    *ngIf="notification.maintenanceTimeRange"
                    class="agpr-systemNotificationsCard-timeRangeItem"
                >
                    <span class="agpr-systemNotificationsCard-timeRangeItem-label">
                        {{ 'SystemNotification.card.maintenance.end' | localize }}
                    </span>
                    <span class="agpr-systemNotificationsCard-timeRangeItem-value">
                        {{ notification.maintenanceTimeRange.endConvertedwithTz | changeTimeZone: preferences?.timeZone : defaultTimeFormat }}
                    </span>
                </div>
                <div class="agpr-systemNotificationsCard-timeRangeItem">
                    <span class="agpr-systemNotificationsCard-timeRangeItem-label">
                        {{ 'SystemNotification.card.notification.end' | localize }}
                    </span>
                    <span class="agpr-systemNotificationsCard-timeRangeItem-value">
                        {{ notification.notificationTimeRange.endConvertedwithTz | changeTimeZone: preferences?.timeZone : defaultTimeFormat }}
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="agpr-contextMenu bottom right">
        <agpr-button
            [id]="id + '_deleteButton'"
            [icon]="'fa-regular fa-duotone fa-trash-can'"
            tooltip="SystemNotification.action.deleteNotification"
            [style]="buttonTypes.contextMenu"
            (click)="deleteCard()"
        ></agpr-button>
        <agpr-button
            *ngIf="notification.statusBadge.status !== systemNotificationStatusEnum.past"
            [id]="id + '_editButton'"
            [icon]="'fa-regular fa-duotone fa-pen'"
            tooltip="SystemNotification.createDialog.edit"
            [style]="buttonTypes.contextMenu"
            (click)="editNotification()"
        ></agpr-button>
        <agpr-button
            *ngIf="notification.statusBadge.status !== systemNotificationStatusEnum.past"
            [id]="id + '_cancelButton'"
            [icon]="'fa-regular fa-duotone fa-ban'"
            tooltip="SystemNotification.action.end"
            [style]="buttonTypes.contextMenu"
            (click)="editNotification(true)"
        ></agpr-button>
    </div>
</div>